import React from "react";
import { SendReferral } from "components/common/referral";
import { Overlay } from "components/common/insider";

export default props => (
  <Overlay>
    <SendReferral {...props} />
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/Referral/View.js